import { dataPrinterSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPrinterSolid = /*#__PURE__*/createIcon(dataPrinterSolid)
export default IconPrinterSolid
